import styles from './ChangePasswordPage.module.scss';
import contry from '../../../../assets/images/kuwait-flag.png';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import { changePassActions } from '../../../../stores/_actions';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import popup from '../../../components/popup/PopupModel.module.scss';
import Validator from '../../../common/common-functions';
import { PopupModel } from '../../../components/popup/PopupModel';
import popClose from 'assets/images/pop-close.svg';
import { Button } from 'semantic-ui-react';
import { PasswordBox } from '../../../components/PasswordInput/PasswordInput';
import hidden from 'assets/images/icn-show.svg';
import show from 'assets/images/icn-hidden.svg';

function ChangePasswordPage() {
  const history = useHistory();
  const jsonData = localStorage.getItem('customer');
  const customerData = JSON.parse(jsonData);
  const customerCode = localStorage.getItem('CustomerCode');
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  // if (!sessionId) {
  //   history.goBack();
  // }

  const [modelPopup, openPopup] = useState(false);
  const [buttonActive, setButtonActive] = useState(false);
  const location = useLocation();

  const hidePopup = () => {
    openPopup(false);
    if (result && result.statusCode == '200') {
      history.push({ pathname: '/more' });
    }
    dispatch(changePassActions.clearPreviousMessage());
  };

  const [password, setPassword] = useState({
    oldPass: '',
    newPass: '',
    confirmPass: '',
    confirmPassErrorMsg: '',
    newPassErrorMsg: '',
    oldPassErrorMsg: '',
  });
  const errorMsg = '';
  //let payload = {Data : {}};
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: customerCode,
    Data: {
      CustomerCode: customerCode,
      OldPassword: '',
      NewPassword: '',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };
  let result;
  let custDetails;
  useSelector((state) => {
    result = state.changePass?.data;
    custDetails = state.getCustDetails?.data;
  }, []);

  const [type, TextType] = useState('password');
  const [type2, TextType2] = useState('password');
  const [type3, TextType3] = useState('password');

  const InputType = (e) => (type == 'password' ? TextType('text') : TextType('password'));

  const InputType2 = (e) => (type2 == 'password' ? TextType2('text') : TextType2('password'));

  const InputType3 = (e) => (type3 == 'password' ? TextType3('text') : TextType3('password'));

  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == 'confirmPass') {
      if (!value) {
        setPassword((password) => ({ ...password, confirmPass: '', confirmPassErrorMsg: 'Confirm Transaction Password is required' }));
        return;
      }
      // else if (!Validator.alphanumberic(value)) {
      //   errorMsg = 'Only alphnumeric allowed';
      //   setPassword((password) => ({ ...password, confirmPassErrorMsg: errorMsg }));
      //   return;
      // }
      setPassword((password) => ({ ...password, confirmPassErrorMsg: '' }));
    } else if (name == 'newPass') {
      if (!value) {
        setPassword((password) => ({ ...password, newPass: '', newPassErrorMsg: 'New Transaction Password is required' }));
        return;
      }
      // else if (!Validator.alphanumberic(value)) {
      //   errorMsg = 'Only alphnumeric allowed';
      //   setPassword((password) => ({ ...password, newPassErrorMsg: errorMsg }));
      //   return;
      // }
      setPassword((password) => ({ ...password, newPassErrorMsg: '' }));
    } else if (name == 'oldPass') {
      if (!value) {
        setPassword((password) => ({ ...password, oldPass: '', oldPassErrorMsg: 'Current Transaction Password is required' }));
        return;
      }
      // else if (!Validator.alphanumberic(value)) {
      //   errorMsg = 'Only alphnumeric allowed';
      //   setPassword((password) => ({ ...password, oldPassErrorMsg: errorMsg }));
      //   return;
      // }
      setPassword((password) => ({ ...password, oldPassErrorMsg: '' }));
    }
    //  setPassword((pass) => ({ ...pass, errorMsg: '' }));
    //  if (name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six') {

    setPassword((password) => ({ ...password, [name]: value }));
  };

  const [submitted, setSubmitted] = useState(false);
  // setSubmitted(true);
  const handleSubmit = (e) => {
    e.preventDefault();
    let error = false;
    setSubmitted(true);
    // if (!password.oldPass || !password.newPass || !password.confirmPass) {
    if (!password.oldPass) {
      setPassword((password) => ({ ...password, oldPassErrorMsg: 'Current Transaction Password is required' }));
      error = true;
    } else if (password.oldPass.length != 8) {
      setPassword((password) => ({ ...password, oldPassErrorMsg: 'Please enter 8 char Current Transaction password' }));
      error = true;
    }
    if (!password.newPass) {
      setPassword((password) => ({ ...password, newPassErrorMsg: 'New Transaction Password is required' }));
      error = true;
    } else if (password.newPass.length != 8) {
      setPassword((password) => ({ ...password, newPassErrorMsg: 'Please enter 8 char New Transaction password' }));
      error = true;
    }
    if (!password.confirmPass) {
      setPassword((password) => ({ ...password, confirmPassErrorMsg: 'Confirm Transaction Password is required' }));
      error = true;
    } else if (password.confirmPass.length != 8) {
      setPassword((password) => ({ ...password, confirmPassErrorMsg: 'Please enter 8 char Confirm New Transaction password' }));
      error = true;
    } else if (password.newPass.length === 8 && password.newPass !== password.confirmPass) {
      setPassword((password) => ({
        ...password,
        confirmPassErrorMsg: 'New Transaction  and Confirm New Transaction Password should be same',
      }));
      error = true;
    }
    if (error) {
      return;
    }
    payload.Data['OldPassword'] = password.oldPass;
    payload.Data['NewPassword'] = password.newPass;
    payload.Data['CustomerCode'] = custDetails?.CustomerCode;
    openPopup(true);
    dispatch(changePassActions.changePass(payload));
  };

  const handleBackBtn = () => {
    history.push('/more');
  };
  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.ChangeTransactionPassword.heading}</h1>
          <form name="password" autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.ChangeTransactionPassword.oldPass}</label>
              <input type={type} name="oldPass" maxLength="8" autoComplete="off" value={password.oldPass} onChange={handleChange} />
              <img
                src={type == 'text' ? hidden : show}
                alt=""
                onClick={(e) => InputType(e)}
                className={type == 'text' ? styles.LoginPage__formBox__hidden : styles.LoginPage__formBox__show}
              />
              {submitted && password.oldPassErrorMsg ? <div className={styles.formgroup__error}>{password.oldPassErrorMsg}</div> : ''}
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.ChangeTransactionPassword.newPass}</label>
              <input type={type2} name="newPass" maxLength="8" autoComplete="off" value={password.newPass} onChange={handleChange} />
              <img
                src={type2 == 'text' ? hidden : show}
                alt=""
                onClick={(e) => InputType2(e)}
                className={type2 == 'text' ? styles.LoginPage__formBox__hidden : styles.LoginPage__formBox__show}
              />
              {submitted && password.newPassErrorMsg ? <div className={styles.formgroup__error}>{password.newPassErrorMsg}</div> : ''}
            </div>
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.ChangeTransactionPassword.confirmPass}</label>
              <input type={type3} name="confirmPass" maxLength="8" autoComplete="off" value={password.confirmPass} onChange={handleChange} />
              <img
                src={type3 == 'text' ? hidden : show}
                alt=""
                onClick={(e) => InputType3(e)}
                className={type3 == 'text' ? styles.LoginPage__formBox__hidden : styles.LoginPage__formBox__show}
              />
              {submitted && password.confirmPassErrorMsg ? <div className={styles.formgroup__error}>{password.confirmPassErrorMsg}</div> : ''}
            </div>
            <input type="button" value="Back" className={styles.LoginPage__link} onClick={handleBackBtn} />
            <input type="submit" value={Label.ChangeTransactionPassword.buttonLabel} className={styles.LoginPage__link} onClick={handleSubmit} />
          </form>
        </div>
      </div>
      {modelPopup ? (
        <div className={popup.dialogue}>
          <div className={popup.dialogue__wrap}>
            <img className={popup.dialogue__close} src={popClose} onClick={hidePopup} />
            {result?.statusCode && (
              <>
                <p>{result.message}</p>
                <br />
              </>
            )}
            {/* <p>It looks like your have not registered with us before. Please click below to register with before proceeding ahead.</p> */}
            <div className={styles.pageLeft__buttonCenter} style={{ textAlign: 'center' }}>
              {/* <Link onClick={hidePopup}>OK</Link> */}
              <Button onClick={hidePopup} className="ui button">
                {' '}
                OK
              </Button>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </LoadingIndicator>
  );
}

export { ChangePasswordPage };
